import React, { useEffect, useState } from 'react'
import { Container, NavItem, NavItemIcon, NavItemText } from './MobileNavbar.style'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { searchRoute } from '../../views/Search/route'
import { loginRoute } from '../../views/Login/route.const'
import { profileRoute } from '../../views/Profile/route.const'
import { useIsLoggedIn } from '../../hooks/useAuth'
import { homeRoute } from '@views/Home/route.const'
import { checkoutRoute } from '@views/Checkout/route'
import { TFunction } from 'i18next'

const createTabs = (t: TFunction, isLoggedIn: boolean) =>
    [
        {
            id: 'home',
            icon: 'wemolo-wemolo-icon',
            text: t('footer.home'),
            route: homeRoute()
        },
        {
            id: 'book',
            icon: 'wemolo-parking-ok',
            text: t('footer.reservation'),
            route: [searchRoute(), 'booking/lot/', checkoutRoute()]
        },
        {
            id: 'login',
            icon: 'wemolo-user',
            text: isLoggedIn ? t('footer.profile') : t('footer.login'),
            route: [loginRoute(), profileRoute()]
        }
    ] as const

const MobileNavbar = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const location = useLocation()
    const isLoggedIn = useIsLoggedIn()
    const tabs = createTabs(t, isLoggedIn)
    const [selected, setSelected] = useState(() => {
        const tab = tabs.find((tab) => {
            if (Array.isArray(tab.route)) {
                return tab.route.some((route) => location.pathname.includes(route))
            }

            return location.pathname === tab.route
        })

        if (tab) return tab.id
        return null
    })

    const onTabClick = (tab: (typeof tabs)[number]) => {
        setSelected(tab.id)

        if (tab.id === 'book') {
            return history.push(tab.route[0])
        }

        if (typeof tab.route === 'string') {
            return history.push(tab.route)
        }

        if (Array.isArray(tab.route)) {
            // TODO: Improve hardoded tab indexes (at least they are readonly now)
            return history.push(isLoggedIn ? tab.route[1] : tab.route[0])
        }

        console.error('Invalid tab route', tab)
    }

    return (
        <Container>
            {tabs.map((tab) => (
                <NavItem role="button" key={tab.id} onClick={() => onTabClick(tab)} $selected={tab.id === selected}>
                    <NavItemIcon className={tab.icon} aria-hidden="true" />
                    <NavItemText>{tab.text}</NavItemText>
                </NavItem>
            ))}
        </Container>
    )
}

export default MobileNavbar
